export const fileTypeCategories = {
  image: {
    mimeTypes: 'image/png,image/jpeg,image/gif,image/webp,image/svg+xml,image/bmp',
    icon: 'mdi-image-outline'
  },
  video: {
    mimeTypes: 'video/mpeg,video/mp4,video/ogg,video/webm,application/vnd.apple.mpegurl',
    icon: 'mdi-video-outline'
  },
  audio: {
    mimeTypes: 'audio/mpeg,audio/mp4,audio/ogg,audio/weba,audio/flac,audio/aac',
    icon: 'mdi-volume-high'
  },
  document: {
    mimeTypes: 'text/plain,text/rtf,application/pdf,application/vnd.oasis.opendocument.presentation,application/vnd.oasis.opendocument.spreadsheet,application/vnd.oasis.opendocument.text,application/vnd.ms-powerpoint,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.presentation',
    icon: 'mdi-file-document-outline'
  },
  archive: {
    mimeTypes: 'application/zip,application/x-7z-compressed,application/x-rar-compressed,application/gzip,application/x-tar',
    icon: 'mdi-archive-outline'
  },
  file: {
    icon: 'mdi-file-outline'
  }
}

export type FileTypeCategory = keyof typeof fileTypeCategories

export const fileTypeInfo = (urlOrExtension: string) => {
  const defaultFileTypeData = { category: 'file', icon: fileTypeCategories.file.icon }
  const mapping = {
    png: { category: 'image', mimeType: 'image/png' },
    jpg: { category: 'image', mimeType: 'image/jpeg' },
    jpeg: { category: 'image', mimeType: 'image/jpeg' },
    gif: { category: 'image', mimeType: 'image/gif' },
    webp: { category: 'image', mimeType: 'image/webp' },
    svg: { category: 'image', mimeType: 'image/svg+xml' },
    bmp: { category: 'image', mimeType: 'image/bmp' },
    m3u8: { category: 'video', mimeType: 'application/vnd.apple.mpegurl' },
    mp4: { category: 'video', mimeType: 'video/mp4' },
    m4v: { category: 'video', mimeType: 'video/mp4' },
    mpeg: { category: 'video', mimeType: 'video/mpeg' },
    ogv: { category: 'video', mimeType: 'video/ogg' },
    oga: { category: 'audio', mimeType: 'audio/ogg' },
    ogg: { category: 'audio', mimeType: 'audio/ogg' },
    mp3: { category: 'audio', mimeType: 'audio/mpeg' },
    flac: { category: 'audio', mimeType: 'audio/flac' },
    aac: { category: 'audio', mimeType: 'audio/aac' },
    txt: { category: 'document', mimeType: 'text/plain' },
    rtf: { category: 'document', mimeType: 'text/rtf' },
    pdf: { category: 'document', mimeType: 'application/pdf' },
    odp: { category: 'document', mimeType: 'application/vnd.oasis.opendocument.presentation' },
    ods: { category: 'document', mimeType: 'application/vnd.oasis.opendocument.spreadsheet' },
    odt: { category: 'document', mimeType: 'application/vnd.oasis.opendocument.text' },
    pps: { category: 'document', mimeType: 'application/vnd.ms-powerpoint' },
    ppt: { category: 'document', mimeType: 'application/vnd.ms-powerpoint' },
    pptx: { category: 'document', mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' },
    xls: { category: 'document', mimeType: 'application/vnd.ms-excel' },
    xlsx: { category: 'document', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
    doc: { category: 'document', mimeType: 'application/msword' },
    docx: { category: 'document', mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
    zip: { category: 'archive', mimeType: 'application/zip' },
    '7z': { category: 'archive', mimeType: 'application/x-7z-compressed' },
    rar: { category: 'archive', mimeType: 'application/x-rar-compressed' },
    gzip: { category: 'archive', mimeType: 'application/gzip' },
    tar: { category: 'archive', mimeType: 'application/x-tar' }
  }

  const segments = urlOrExtension.split('/')
  const name = segments[segments.length - 1]
  const nameParts = name.split('.')
  const extension = nameParts[nameParts.length - 1].toLowerCase() || ''

  const fileTypeData = mapping[extension] || defaultFileTypeData

  return {
    category: fileTypeData.category,
    mimeType: fileTypeData.mimeType,
    icon: fileTypeCategories[fileTypeData.category as FileTypeCategory]?.icon || fileTypeCategories.file.icon
  }
}
